import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as JsBarcode from 'jsbarcode';
import { AppService } from 'src/app/service/app.service';
import { ShippingService } from "../../service/shipping.service";

@Component({
  selector: 'app-thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.scss']
})
export class ThanksComponent implements OnInit {
  public data: any = null;
  private barcodeNumber: string = '';

  constructor(
      private router: Router,
      private route: ActivatedRoute,
      private appService: AppService,
      private shippingService: ShippingService,
  ) {}

  ngOnInit(): void {
    const lang = this.route.snapshot.queryParams['hl'];
    const currentLang = this.getSelectedLang(lang);
    this.appService.selectedLangListener.next(currentLang);

    this.loadShippingData();
  }

  private loadShippingData(): void {
    const token = this.route.snapshot.queryParams['token'];

    if (!token) {
      this.router.navigate(['carry-reserve/error_url_ng']);
      return;
    }

    this.validateTokenAndGetData(token);
  }

  private validateTokenAndGetData(token: string): void {
    this.shippingService.getShippingRequestByToken(token).subscribe({
      next: (response) => {
        if (response.status === 200 && response.data) {
          this.data = response.data;

          this.barcodeNumber = this.formatBarcodeNumber(response.data.id);

          if (response.data.usageDate) {
            this.data.usageDate = response.data.usageDate;
          }

          setTimeout(() => {
            this.generateBarcode();
          }, 100);
        } else {
          this.router.navigate(['carry-reserve/error_url_ng']);
        }
      },
      error: () => {
          this.router.navigate(['carry-reserve/error_url_ng']);
      }
    });
  }

  private formatBarcodeNumber(shipId: number): string {
    return shipId.toString().padStart(8, '0');
  }

  private generateBarcode(): void {
    const barcodeElement = document.getElementById('barcode');
    if (barcodeElement && this.barcodeNumber) {
        JsBarcode('#barcode', this.barcodeNumber, {
          width: 3,
          height: 50,
          displayValue: true,
          textPosition: 'top',
          textAlign: 'center',
          fontSize: 50,
          background: "#EBE6C8",
          lineColor: '#490E00'
        });
    }
  }

  public goToTop(): void {
    sessionStorage.removeItem('shippingData');
    this.router.navigate(['carry-reserve']);
  }

  getSelectedLang(lang: string): number {
    switch (lang) {
      case 'ja': return 0;
      case 'en': return 1;
      case 'ko': return 2;
      case 'cn': return 3;
      case 'tw': return 4;
      default: return 0;
    }
  }
}
